import Coolwhip from '../../../coolwhip/assets/js/dist/coolwhip';
import zipFormWidget from './components/_zip-form-widget';

const CLWP = new Coolwhip();

CLWP.init();
zipFormWidget();

import './components/_business-loan-calculator';
